import React, { Component } from 'react';

import { capitaliseFirstChar, classNames } from '../../utilities';

import styles from './AdminMenu.css';
import { adminMenuChildPropTypes } from './admin-menu-prop-types';

export class AdminMenuItem extends Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);

    this.state = { popupOpen: false };
  }

  handleClick() {
    this.setState(prevState => ({ popupOpen: !prevState.popupOpen }));
  }

  render() {
    const { item } = this.props;
    const { popupOpen } = this.state;
    const { handleClick } = this;

    return (
      <li className={styles.adminMenuListItem}>
        {item.items ? (
          <button
            aria-expanded={popupOpen}
            aria-haspopup={!!item.items}
            className={classNames(
              styles.adminMenuListItemButton,
              styles[`adminIcon${capitaliseFirstChar(item.icon)}`]
            )}
            onClick={handleClick}
            type="button">
            <span className={styles.adminMenuListItemButtonText}>{item.title}</span>
          </button>
        ) : (
          <a
            className={classNames(
              styles.adminMenuListItemLink,
              styles[`adminIcon${capitaliseFirstChar(item.icon)}`]
            )}
            href={item.url}>
            {item.title}
          </a>
        )}

        {item.items && (
          <ul
            aria-hidden={!popupOpen}
            className={classNames(styles.adminMenuPopup, popupOpen && styles.isShown)}>
            {item.items.map(subItems => (
              <li className={styles.adminMenuPopupItem} key={subItems.title}>
                <a
                  className={classNames(
                    styles.adminMenuPopupItemLink,
                    styles[`adminIcon${capitaliseFirstChar(subItems.icon)}`]
                  )}
                  href={subItems.url}>
                  {subItems.title}
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  }
}

AdminMenuItem.propTypes = {
  // eslint-disable-next-line react/require-default-props, react/no-typos
  item: adminMenuChildPropTypes.item
};
